
// window.addEventListener("load", () => { });

// function checkURLAndDisplay() {
//   var url = window.location.href;
//   if (url.includes("/collections/monphell/products/")) {
//     var brandMonphell = document.getElementById("brand-monphell");
//     var brandLlehpnom = document.getElementById("brand-llehpnom");
//     var relevantMonphell = document.getElementById("relevant-monphell");
//     var relevantllehpnom = document.getElementById("relevant-llehpnom");
//     var displayAnotherLogoBrand = document.getElementsByClassName("brand-monphell-link");

//     if (brandMonphell) brandMonphell.style.display = "block";
//     if (brandLlehpnom) brandLlehpnom.style.display = "none";
//     if (relevantMonphell) relevantMonphell.style.display = "block";
//     if (relevantllehpnom) relevantllehpnom.style.display = "none";
//     if (displayAnotherLogoBrand && displayAnotherLogoBrand.length > 0) displayAnotherLogoBrand[0].style.display = "flex";
//   } else if (url.includes("/collections/llehpnom/products/")) {
//     var brandLlehpnom = document.getElementById("brand-llehpnom");
//     var brandMonphell = document.getElementById("brand-monphell");
//     var relevantMonphell = document.getElementById("relevant-monphell"); 
//     var relevantllehpnom = document.getElementById("relevant-llehpnom");
//     var displayAnotherLogoBrand = document.getElementsByClassName("brand-llehpnom-link");

//     if (brandLlehpnom) brandLlehpnom.style.display = "block";
//     if (brandMonphell) brandMonphell.style.display = "none";
//     if (relevantMonphell) relevantMonphell.style.display = "none";
//     if (relevantllehpnom) relevantllehpnom.style.display = "block";
//     if (displayAnotherLogoBrand && displayAnotherLogoBrand.length > 0) displayAnotherLogoBrand[0].style.display = "flex";
//   }
// }


(function () {
  if (window.addtocartScriptLoaded) return;
  window.addtocartScriptLoaded = true;

  document.addEventListener("DOMContentLoaded", function () {
    setupEventListeners();
    // checkURLAndDisplay();
    initializeCartTable();

    var cartWrapperOpenNew = document.getElementsByClassName("cartWrapper")[0];
    cartWrapperOpenNew.onclick = () => {
      document.getElementById("cart-background").style.borderColor = "#000000";
      var addToCartCrossLine3 =
        document.getElementsByClassName("crossing-lines3")[0];
      var addToCartCrossLine4 =
        document.getElementsByClassName("crossing-lines4")[0];
      var btnCartCrossLine1 = document.getElementById("btn-cart-crossLine1");
      var btnCartCrossLine2 = document.getElementById("btn-cart-crossLine2");
      document.getElementById("add-to-cart").style.borderColor = "#000000";
      cartWrapperOpenNew.style.display = "none";
      btnCartCrossLine1.style.opacity = "0";
      btnCartCrossLine2.style.opacity = "0";
      addToCartCrossLine3.style.opacity = "0";
      addToCartCrossLine4.style.opacity = "0";
    };
    ///
    // var arrowOnBtn =document.getElementsById('arrowOnBtn');
    // var dropBtnClick = document.getElementById("dropdownMenuButton");
    // dropBtnClick.addEventListener("click", () => {
    //   dropBtnClick.style.visibility = "hidden";
    // });
    ///
    // ////////////////////////////////////////////////////////////////////
    // var displayAnotherLogoBrandMonphell = document.getElementsByClassName(
    //   "brand-monphell-link"
    // )[0];
    // var displayAnotherLogoBrandllehpnom = document.getElementsByClassName(
    //   "brand-llehpnom-link"
    // )[0];
    // displayAnotherLogoBrandMonphell.addEventListener("click", () => {
    //   //TODO: HERE monphell link in llehpnom page
    // });
    // displayAnotherLogoBrandllehpnom.addEventListener("click", () => {
    //   //TODO: HERE llehpnom link in monphell page
    // });
    ////////////////////////////////////////////////////////////////////

    // document
    //   .querySelector("#privacy-policy")
    //   .addEventListener("click", function () {
    //     showFirstBlockSecondNone(
    //       ".privacy-text-container2",
    //       "#products-container-id"
    //     );

    //     showFirstBlockSecondNone(
    //       ".privacy-text-container2",
    //       ".privacy-text-container"
    //     );

    //     showFirstBlockSecondNone(
    //       ".privacy-text-container2",
    //       "#relevant-monphell"
    //     );

    //     showFirstBlockSecondNone(
    //       ".privacy-text-container2",
    //       ".relevant-products-section"
    //     );
    //   });

    document.querySelectorAll("#privacy-policy3").forEach(function(element) {
      element.addEventListener("click", function() {
        showFirstBlockSecondNone(
          ".privacy-text-container2",
          "#productImagesSection"
        );
      });

      element.addEventListener("click", function() {
        showFirstBlockSecondNone(
          ".privacy-text-container2",
          ".relevant-products-section"
        );
      });
    
      element.addEventListener("click", function() {
        showFirstBlockSecondNone(
          ".privacy-text-container2",
          ".products-container"
        );
      });
    });

    // document
    //   .querySelector("#privacy-policy3")
    //   .addEventListener("click", function () {
    //     showFirstBlockSecondNone(
    //       ".privacy-text-container2",
    //       "#relevant-monphell"
    //     );

    //   });

    document.querySelectorAll("#SHIPPING").forEach(function(element) {
      element.addEventListener("click", function() {
        showFirstBlockSecondNone(
          ".privacy-text-container",
          "#products-container-id"
        );
      });

      element.addEventListener("click", function() {
        showFirstBlockSecondNone(
          ".privacy-text-container",
          ".relevant-products-section"
        );
      });
    });
    /*  document
        .querySelector("#book-appointment")
        .addEventListener("click", function () {
          showFirstBlockSecondNone(
            ".privacy-text-container",
            "#products-container-id"
          );
       
         
        }); */

    // document
    //   .querySelector("#brand-monphell")
    //   .addEventListener("click", function () {

    //     showFirstBlockSecondNone(
    //       "#productImagesSection",
    //       ".privacy-text-container"
    //     );
    //     showFirstBlockSecondNone(
    //       "#productImagesSection",
    //       ".privacy-text-container2"
    //     );
    //     /*   var element = document.querySelector("#book-appointment");
    //        if (element) {
    //            element.classList.remove("list-item-selected");
    //        } */
    //     // var element2 = document.querySelector("#privacy-policy");
    //     // if (element2) {
    //     //   element2.classList.remove("list-item-selected");
    //     // }
    //     var element3 = document.querySelector("#SHIPPING");
    //     if (element3) {
    //       element3.classList.remove("list-item-selected");
    //     }
    //   });


    var dropdownItems = document.querySelectorAll(".dropdown-item");
    var priceDisplay = document.querySelector(".price");
    if (dropdownItems.length > 0) {
      var defaultVariantId = dropdownItems[0].dataset.value;
      if (variantPrices && variantPrices[defaultVariantId]) {
        priceDisplay.textContent = variantPrices[defaultVariantId];
      }
    }
    dropdownItems.forEach(function (item) {
      item.addEventListener("click", function () {
        var selectedSize = this.textContent;
        var selectedValue = this.dataset.value;
        document.getElementById("dropdownMenuButton").textContent =
          selectedSize;
        document.getElementById("selectedSize").value = selectedSize;
        if (variantPrices && variantPrices[selectedValue]) {
          priceDisplay.textContent = variantPrices[selectedValue];
        }
      });
    });
    var dropdownItems = document.querySelectorAll(".dropdown-item");
    var form = document.querySelector(".product-form");
    var selectedSizeInput = document.getElementById("selectedSize");
    var quantityInput = document.getElementById("quantity");
    var addToCartButton = document.getElementById("add-to-cart");
    var cartWrapperOpen = document.getElementsByClassName("cartWrapper")[0];
    var addToCartCrossLine3 =
      document.getElementsByClassName("crossing-lines3")[0];
    var addToCartCrossLine4 =
      document.getElementsByClassName("crossing-lines4")[0];
    if (addToCartButton) {
      addToCartButton.addEventListener("click", () => {
        if (addToCartCrossLine3) {
          addToCartCrossLine3.style.opacity = "1";
        }
        if (addToCartCrossLine4) {
          addToCartCrossLine4.style.opacity = "1";
        }
        if (addToCartButton) {
          addToCartButton.style.borderColor = "#0007FF";
        }
        if (cartWrapperOpen) {
          cartWrapperOpen.style.display = "block";
        }
      });
    }

    if (dropdownItems.length > 0) {
      var firstItem = dropdownItems[0];
      var defaultSize = firstItem.textContent;
      var defaultValue = firstItem.dataset.value;
      dropdownMenuButton.textContent = defaultSize;
      selectedSizeInput.value = defaultValue;
    }

    dropdownItems.forEach(function (item) {
      item.addEventListener("click", function () {
        var selectedSize = this.textContent;
        var selectedValue = this.dataset.value;
        dropdownMenuButton.textContent = selectedSize;
        selectedSizeInput.value = selectedValue;
      });
    });

    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var formData = new FormData();
        formData.append("id", selectedSizeInput.value);
        formData.append("quantity", quantityInput.value);

        addItemToCartAjax(formData);
      });
    }
    var sizeDropdown = document.getElementById("sizeDropdown");
    var dropdownToggle = document.getElementById("dropdownMenuButton");
    var noSizesFound = document.getElementById("noSizesFound");
    var disablingAddToCart = document.getElementById("add-to-cart");
    var hasSizes = false;

    var dropdownItems = sizeDropdown.getElementsByClassName("dropdown-item");
    for (var i = 0; i < dropdownItems.length; i++) {
      if (!dropdownItems[i].classList.contains("disabled")) {
        hasSizes = true;
        if (i === 0) {
          dropdownItems[i].classList.add("selected");
          dropdownToggle.textContent = dropdownItems[i].textContent;
        }
        break;
      }
    }

    if (!hasSizes) {
      // No sizes available
      noSizesFound.style.display = "block";
      dropdownToggle.disabled = true;
      disablingAddToCart.disabled = true;
      document.getElementsByClassName("price")[0].style.display = "none";
    } else {
      // Sizes are available
      noSizesFound.style.display = "none";
      dropdownToggle.disabled = false;
      disablingAddToCart.disabled = false;
    }

    document.querySelectorAll(".increase-btn").forEach(function (button) {
      button.addEventListener("click", function () {
        var itemId = this.getAttribute("data-item-id");
        increaseQuantity(itemId);
      });
    });

    document.querySelectorAll(".remove-btn").forEach(function (button) {
      button.addEventListener("click", async function () {
        var itemId = this.getAttribute("data-item-id");
        removeItemFromCart(itemId);
      });
    });
    document.querySelectorAll(".decrease-btn").forEach(function (button) {
      button.addEventListener("click", function () {
        var itemId = this.getAttribute("data-item-id");
        decreaseQuantity(itemId);
      });
    });
    // document.getElementById("close-btn-menu").addEventListener("click", () => {
    //   var menu = document.querySelector(".navbar-menu-open");
    //   menu.style.display = "none";
    //   btnMenuCrossLine1.style.display = "none";
    //   btnMenuCrossLine2.style.display = "none";
    //   menuBtn.style.borderColor = "#000000";
    // });
    // document.getElementById("close-btn-shop").addEventListener("click", () => {
    //   var shop = document.querySelector(".navbar-shop-open");
    //   shop.style.display = "none";
    //   btnShopCrossLine1.style.display = "none";
    //   btnShopCrossLine2.style.display = "none";
    //   shopBtn.style.borderColor = "#000000";
    // });
    const sliders = document.querySelectorAll(".image-slider");

    sliders.forEach((slider) => {
      let isDown = false;
      let startX;
      let scrollLeft;

      slider.addEventListener("mousedown", (e) => {
        isDown = true;
        slider.classList.add("active");
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });

      slider.addEventListener("mouseleave", () => {
        isDown = false;
        slider.classList.remove("active");
      });

      slider.addEventListener("mouseup", () => {
        isDown = false;
        slider.classList.remove("active");
      });

      slider.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 1.5; //scroll-fast
        slider.scrollLeft = scrollLeft - walk;
      });
    });
    var dropdownButton = document.getElementById("dropdownMenuButton");
    var formContainer = document.querySelector(".container");

    dropdownButton.addEventListener("show.bs.dropdown", function () {
      formContainer.classList.add("dropdown-open");
    });

    dropdownButton.addEventListener("hide.bs.dropdown", function () {
      formContainer.classList.remove("dropdown-open");
    });
    $(document).ready(function () {
      $("#contact")
        .on("show.bs.modal", function () {
          $(".world-wide-close").show();
        })
        .on("hide.bs.modal", function () {
          $(".world-wide-close").hide();
        });

      if ($("#newsletter").length) {
        $("#newsletter")
          .on("show.bs.modal", function () {
            if ($(".world-wide-close").length) {
              $(".world-wide-close").show();
            }
          })
          .on("hide.bs.modal", function () {
            if ($(".world-wide-close").length) {
              $(".world-wide-close").hide();
            }
          });
      }

      $("#about-us")
        .on("show.bs.modal", function () {
          $(".world-wide-close").show();
        })
        .on("hide.bs.modal", function () {
          $(".world-wide-close").hide();
        });

      $(".world-wide-close").click(function () {
        var openModal = $(".modal.show");
        if (openModal.length) {
          var bootstrapModal = bootstrap.Modal.getInstance(openModal[0]);
          bootstrapModal.hide();
        }
      });
    });
    // document.getElementById("privacy-policy").onclick = () => {
    //   closeMenuView();
    // };
    document.getElementById("SHIPPING").onclick = () => {
      closeMenuView();
    };
    //  document.getElementById("book-appointment").onclick = () => {
    //   closeMenuView();
    // }; 
    document.getElementById("aboutUsBtn").onclick = () => {
      let controllingContainer = document.getElementsByClassName(
        "controlling-container"
      )[0];
      let insetWrapper = document.getElementsByClassName("inset-wrapper")[0];
      document.getElementById("about-close-icon").classList.remove("d-none");
      document.getElementById("about-close-icon").classList.add("d-flex");
      insetWrapper.classList.remove("d-none");
      controllingContainer.classList.remove("d-none");
    };
    var insetWrapper = document.getElementsByClassName("inset-wrapper")[0];
    insetWrapper.onclick = () => {
      let controllingContainer = document.getElementsByClassName(
        "controlling-container"
      )[0];
      document.getElementById('about-close-icon').classList.add('d-none');
      document.getElementById('about-close-icon').classList.remove('d-flex');
      controllingContainer.classList.add("d-none");
      insetWrapper.classList.add("d-none");
    };



    // Ensure this code runs after the DOM has fully loaded
    document.addEventListener('DOMContentLoaded', function () {
      const newsletterBtn = document.getElementById("newsletterBtn");
      const insetWrapperNewsletter = document.getElementsByClassName("inset-wrapper-newsletter")[0];
      const modalContentWrapper = document.getElementsByClassName("modal-content-wrapper")[0];
      const newsletterCloseIcon = document.getElementById('newsletter-close-icon');

      // Function to show the newsletter popup
      function showNewsletterPopup() {
        newsletterCloseIcon.classList.remove('d-none');
        newsletterCloseIcon.classList.add('d-flex');
        insetWrapperNewsletter.classList.remove("d-none");
        document.getElementsByClassName("controlling-container-newsletter")[0].classList.remove("d-none");
      }

      // Function to hide the newsletter popup
      function hideNewsletterPopup() {
        newsletterCloseIcon.classList.add('d-none');
        newsletterCloseIcon.classList.remove('d-flex');
        document.getElementsByClassName("controlling-container-newsletter")[0].classList.add("d-none");
        insetWrapperNewsletter.classList.add("d-none");
      }

      // Click event for the newsletter button
      if (newsletterBtn) {
        newsletterBtn.onclick = showNewsletterPopup;
      }

      // Click event for the inset wrapper to close the popup, if clicking outside the modal content
      if (insetWrapperNewsletter) {
        insetWrapperNewsletter.addEventListener('click', function (event) {
          if (!modalContentWrapper.contains(event.target)) {
            hideNewsletterPopup();
          }
        });
      }

      // Prevent closing when clicking inside the modal content
      if (modalContentWrapper) {
        modalContentWrapper.addEventListener('click', function (event) {
          event.stopPropagation();
        });
      }
    });

  });


  async function addItemToCartAjax(formData) {
    try {
      const addResponse = await fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      });

      if (!addResponse.ok) {
        throw new Error("Network response was not ok");
      }

      // Fetch the updated cart
      const cartResponse = await fetch("/cart.js");
      const cart = await cartResponse.json();
      if (cart.item_count > 0) {
        document.getElementsByClassName("empty-cart")[0].style.display = "none";
        document.getElementsByClassName("titles-for-headers")[0].style.display =
          "grid";
      }

      const tableBody = document
        .querySelector(".cart-content");
      tableBody.innerHTML = "";

      cart.items.forEach((item) => {
        renderCartTable(cart.items, cart.total_price);
      });
      bindButtonEvents(cart.items.length, cart.id);
    } catch (error) { }
  }

  function renderCartTable(items, total) {
    const tableBody = document
      .querySelector(".cart-content");

    tableBody.innerHTML = "";

    items.forEach((item) => {
      let row = document.createElement("div");
      row.setAttribute("data-item-id", item.id);
      let formattedPrice = formatCurrency(item.final_line_price, "USD"); // Replace 'BGN' with the actual currency code if different
      row.innerHTML = `
      <div data-label="Product">
        <div class="product-container">
          ${item.product_title}
          <button class="remove-btn small-screen-close-btn" data-item-id="${item.id}"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-square" viewBox="0 0 16 16">
          <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
            </svg></button>      
          </div>
        </div>
          <div data-label="Size" class="size-desktop">${item.variant_title}</div>
          <div data-label="Quantity" class="quantity-controls px-0 ">
            <button class="decrease-btn px-0 " data-item-id="${item.id}"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-dash-lg" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8"/>
          </svg></button>
            <input type="number" class="quantity-display px-0" value="${item.quantity}" min="1" data-item-id="${item.id}" disabled >
            <button class="increase-btn px-0 " data-item-id="${item.id}"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"/>
          </svg></button>
          </div>
          <div data-label="Price" class="px-0 price-mb">${formattedPrice}</div>
        <div class="delete-desktop">
          <button class="remove-btn delete-row-Btn" data-item-id="${item.id}" type="button">
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="0.5" y="0.5" width="9" height="9" stroke="#F9F8F4"></rect>
  <path d="M0.5 0.5L9.5 9.5" stroke="#F9F8F4"></path>
  <path d="M9.5 0.5L0.5 9.5" stroke="#F9F8F4"></path>
</svg>
          </button>
        </div>
    `;

      tableBody.appendChild(row);
    });

    let totalRow = document.createElement("div");
    totalRow.classList.add("total-row");
    var formattedTotal = formatCurrency(total, "USD");
    totalRow.innerHTML = `
    <div colspan="3" class="text-right">Total:</div>
    <div>${formattedTotal}</div>
  `;
    tableBody.appendChild(totalRow);

    // Add the buttons row
    let buttonsRow = document.createElement("div");
    buttonsRow.classList.add("buttons-row");
    buttonsRow.innerHTML = `
    <div colspan="5" class="text-center bottom-buttons">
      <div class="buttons-container">
        <button id="continue-shopping-button" class="btn-secondary table-btn btn-animate">Continue Shopping
        <div class="continue-shopping-left-line"></div>
        <div class="continue-shopping-right-line"></div>
        </button>
        <button id="checkout-button" class="btn-primary table-btn btn-animate">Checkout
        <div class="checkout-left-line"></div>
        <div class="checkout-right-line"></div>
        </button>
      </div>
    </div>
  `;
    tableBody.appendChild(buttonsRow);
  }

  //////////////////////////////////////////////////////////////////
  function increaseQuantity(itemId) {
    var quantityInput = document.querySelector(
      `.quantity-display[data-item-id="${itemId}"]`
    );
    var currentQuantity = parseInt(quantityInput.value);
  
    var newQuantity = currentQuantity + 1;
  
    var formData = new FormData();
    formData.append("id", itemId);
    formData.append("quantity", newQuantity);
  
    updateCartAjax(formData, itemId, quantityInput, newQuantity);
  }
  ////////////////////////////////////////////////////////////////////
  function decreaseQuantity(itemId) {
    var quantityInput = document.querySelector(
      `.quantity-display[data-item-id="${itemId}"]`
    );
    var currentQuantity = parseInt(quantityInput.value);
  
    var newQuantity = currentQuantity > 1 ? currentQuantity - 1 : 1;
  
    var formData = new FormData();
    formData.append("id", itemId);
    formData.append("quantity", newQuantity);
  
    updateCartAjax(formData, itemId, quantityInput, newQuantity);
  }

  ////////////////////////////////////////////////////////////////////

  function updateCartAjax(formData, itemId, quantityInput, newQuantity) {
    fetch("/cart/change.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then((data) => {
        // Only update the quantity input if the request was successful
        quantityInput.value = newQuantity;
        initializeCartTable();
      })
      .catch((error) => {
        console.error("Error updating cart:", error);
      });
  }

  // ////////////////////////////////////////////////////////////////////
  function removeItemFromCart(itemId) {
    var formData = new FormData();
    formData.append("updates[" + itemId + "]", 0);

    fetch("/cart/update.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((cart) => {
        if (cart.item_count === 0) {
          const totalRowTable = document.querySelector(".total-row");
          totalRowTable.remove();
        }

        const tableBody = document
          .querySelector(".cart-content");

        // Find and remove all rows with the given itemId
        const itemRows = tableBody.querySelectorAll(`div[data-item-id="${itemId}"]`);
        itemRows.forEach(row => row.remove());

        initializeCartTable();
      })
      .catch((error) => {
        // Handle the error
      });
  }


  function setupEventListeners() {
    const tableBody = document
      .querySelector(".cart-content");

    tableBody.addEventListener("click", function (event) {
      const target = event.target;

      const button = target.closest("button");
      if (button) {
        const itemId = button.dataset.itemId;

        if (button.classList.contains("increase-btn")) {
          increaseQuantity(itemId);
        } else if (button.classList.contains("decrease-btn")) {
          decreaseQuantity(itemId);
        } else if (button.classList.contains("remove-btn")) {
          removeItemFromCart(itemId);
        } else {
          return;
        }
      }
    });
  }

  function initializeCartTable() {
    var headers = document.getElementsByClassName("titles-for-headers")[0];
    var emptyCart = document.getElementsByClassName("empty-cart")[0];
    fetch("/cart.js")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((cart) => {
        if (cart.item_count === 0) {
          headers.style.display = "none";
          emptyCart.style.display = "flex";
          bindButtonEvents(cart.items.length, cart.id);
          return;
        } else {
          headers.style.display = "grid";
          emptyCart.style.display = "none";
          const tableBody = document
            .querySelector(".cart-content");
          tableBody.innerHTML = "";

          cart.items.forEach((item) => {
            renderCartTable(cart.items, cart.total_price);
          });
          bindButtonEvents(cart.items.length, cart.id);
        }
      })
      .catch((error) => { });
  }

  function showFirstBlockSecondNone(displaySelector, noneSelector) {
  
    document.querySelector(displaySelector).style.display = "block";
    document.querySelector(noneSelector).style.display = "none";
  }
  proceedPayment = () => {
    window.location.href = "/checkout";
  };
  function formatCurrency(value, currencyCode) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currencyCode,
    }).format(value / 100);
  }
  function bindButtonEvents(CartItemsLength, cartId) {
    var addToCartButton = document.getElementById("add-to-cart");
    var cardWrapper = document.getElementsByClassName("cartWrapper")[0];
    var addToCartCrossLine3 =
      document.getElementsByClassName("crossing-lines3")[0];
    var addToCartCrossLine4 =
      document.getElementsByClassName("crossing-lines4")[0];
    const continueShoppingBtn = document.getElementById(
      "continue-shopping-button"
    );
    const checkoutBtn = document.getElementById("checkout-button");
    const smallScreenCloseBtn = document.getElementsByClassName(
      "small-screen-close-btn"
    )[0];
    var btnCartCrossLine1 = document.getElementById("btn-cart-crossLine1");
    var btnCartCrossLine2 = document.getElementById("btn-cart-crossLine2");

    continueShoppingBtn.addEventListener("click", () => {
      document.getElementById("cart-background").style.borderColor = "#000000";
      cardWrapper.style.display = "none";
      btnCartCrossLine1.style.opacity = "0";
      btnCartCrossLine2.style.opacity = "0";
      addToCartButton.style.borderColor = "#000000";
      addToCartCrossLine3.style.opacity = "0";
      addToCartCrossLine4.style.opacity = "0";
    });

    if (checkoutBtn) {
      checkoutBtn.addEventListener("click", () => {
        proceedPayment();
      });
    }
    if (CartItemsLength === 0) {
      continueShoppingBtn.style.display = "none";
      checkoutBtn.style.display = "none";
    }
    if (smallScreenCloseBtn) {
      smallScreenCloseBtn.addEventListener("click", () => {
        removeItemFromCart(smallScreenCloseBtn.dataset.itemId);
      });
    }
  }
  function closeMenuView() {
    var menu = document.querySelector(".navbar-menu-open");
    var btnMenuCrossLine1 = document.getElementById("btn-menu-crossLine1");
    var btnMenuCrossLine2 = document.getElementById("btn-menu-crossLine2");
    var menuBtn = document.getElementsByClassName("menu-item")[0];
    menu.style.display = "none";
    btnMenuCrossLine1.style.opacity = "0";
    btnMenuCrossLine2.style.opacity = "0";
    menuBtn.style.borderColor = "#000000";
  }


  document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      const empty_cart_wrapper = document.querySelector('.empty-cart');
      empty_cart_wrapper.style.display = 'none';
      
      await fetch("/cart/add", {
        method: "post",
        body: new FormData(form),
      });

      const res = await fetch("/cart.js");
      const cart = await res.json();

      initializeCartTable();
      openCartDrawer();
    });
  });

  document.querySelectorAll('a[href="/cart"]').forEach((a) => {
    a.addEventListener("click", (e) => {
      e.preventDefault();
      initializeCartTable();
      openCartDrawer();
    });
  });

  function openCartDrawer() {

    document.getElementById('cart-background').click();
    initializeCartTable();

  }
})();


document.addEventListener('DOMContentLoaded', function() {
  const button = document.querySelector('.size-chart-button');
  const chartWrapper = document.querySelector('.size-chart-wrapper');

  button.addEventListener('click', function() {
      chartWrapper.style.display = 'flex';
  });

  const wrapper = document.querySelector('.add-to-cart-button-wrapper');
  // Get the left and right line elements
  const leftLine = document.querySelector('.add-to-cart-left-line');
  const rightLine = document.querySelector('.add-to-cart-right-line');

  // Add event listener for hover
  wrapper.addEventListener('mouseenter', function() {
    leftLine.style.display = 'block';
    rightLine.style.display = 'block';
  });

  wrapper.addEventListener('mouseleave', function() {
    leftLine.style.display = 'none';
    rightLine.style.display = 'none';
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const sizeChartBackground = document.querySelector('.size-chart-background');
  const closeButton = document.querySelector('.close-pop-up-button');
  const chartWrapper = document.querySelector('.size-chart-wrapper');

  sizeChartBackground.addEventListener('click', function() {
    chartWrapper.style.display = 'none';
  });

  closeButton.addEventListener('click', function() {
    chartWrapper.style.display = 'none';
  });
});